export default __webpack_public_path__ + "static/media/AS.f10b6cec.svg";